<template>
  <div v-if="periods" class="plan-change-period__wrap">
    <div class="plan-change-period__title">
      {{ $t('title') }}
    </div>
    <div class="plan-change-period__text">
      {{ $t('select') }}
    </div>
    <div v-for="(period, index) in periods" :key="index" class="plan-item">
      <PaymentDialogPeriodItem
        :key="index"
        @input="onInput"
        :selected="selected"
        :plan="plan"
        :period="period"
      />
    </div>
  </div>
</template>

<script>
import usePeriod from '@/compositions/accounting/usePeriod';
import { ref } from '@vue/composition-api';
import PaymentDialogPeriodItem from '@/components/Payment/Periods/PaymentDialogPeriodItem';

export default {
  name: 'PaymentDialogModalPeriods',
  components: { PaymentDialogPeriodItem },
  props: {
    plan: {
      type: Object,
      required: true,
    },
  },
  setup(_, { emit }) {
    const { periods, fetch } = usePeriod();
    fetch();
    const selected = ref(null);

    function onInput(val) {
      selected.value = val;
      emit('input', val);
    }

    function isSelected(period) {
      return selected.value?.id === period.id;
    }

    return {
      periods,
      selected,
      isSelected,
      onInput,
    };
  },
};
</script>

<style lang="scss" scoped>
  .plan-change-period {
    &__wrap {
      text-align: center;
      margin-bottom: 2rem;
    }
    &__title {
      font-size: 2.125rem;
      line-height: 1.32;
      font-weight: 400;
      text-align: center;
      color: #091A35;
      margin-bottom: 0.625rem;
    }
    &__text {
      font-size: 1.0625rem;
      font-weight: 400;
      line-height: 1.53;
      color: #091A35;
      margin-bottom: 1.25rem;
    }
  }
  .plan-item {
    display: inline-block;
    max-width: 15rem;
    vertical-align: top;
    margin-right: 1.625rem;
    &:last-child {
      margin-right: 0;
    }
  }
  @media #{map-get($display-breakpoints, 'md-and-down')} {
    .plan-change-period {
      &__wrap {
        max-width: 56rem;
        margin: 0 auto 0.5rem auto;
      }
      &__title {
        font-size: 1.75rem;
        line-height: 1.2;
      }
      &__text {
        font-size: 1rem;
        font-weight: 400;
        line-height: 1.53;
        color: #091A35;
        margin-bottom: 1.25rem;
      }
    }
    .plan-item {
      max-width: 50%;
      vertical-align: top;
      margin-right: 1.25rem;
      margin-bottom: 1.25rem;
      &:last-child {
        margin-right: 1.25rem;
      }
    }
  }
  @media #{map-get($display-breakpoints, 'sm-and-down')} {
    .plan-change-period__wrap {
      max-width: 48rem;
    }
    .plan-item {
      max-width: 50%;
     &:nth-child(2n) {
       margin-right: 0;
     }
    }
  }
  @media #{map-get($display-breakpoints, 'xs-only')} {
    .plan-change-period {
      padding: 1.875rem 1.25rem;
      &__wrap {
        margin-bottom: 1.5rem;
      }
      &__title {
        font-size: 1.25rem;
        line-height: 1.1;
        padding: 0 1.125rem;
      }
      &__text {
        font-size: 1rem;
        font-weight: 400;
        line-height: 1.53;
        color: #091A35;
        margin-bottom: 0.875rem;
      }
    }
    .plan-item {
      display: block;
      max-width: 100%;
      margin-right: 0;
      margin-bottom: 0.3125rem;
      &:last-child {
        margin-right: 0;
      }
    }
  }
</style>

<i18n lang="yml" locale="ru">
  title: Изменение платёжного периода
  select: Изменение платёжного периода вступит в силу после завершения текущего оплаченного периода. Выбор влияет на сумму списания при продлении подписки, прямо сейчас с вашей карты ничего не будет списано.
</i18n>

<i18n lang="yml" locale="en">
  title: Change payment period
  select: Any change in your billing period will take effect at the end of the current billing period. Your choice will affect the amount you will be charged when your subscription is renewed. Right now, your card will not be charged.
</i18n>
